import ContentContainer from './content_container';

const Content = ContentContainer;

export default Content;
